import React, { FC, Fragment } from "react";

import { Button, LinkButton } from "~/ui";

type PropsType = {
  cols: number;
  className?: string;
  buttons: {
    text: string;
    onClick?: () => void;
    link?: string;
    isHidden?: boolean;
    readonly?: boolean;
  }[];
};

export const OpenedMenuInGrid: FC<PropsType> = ({
  cols,
  className = "",
  buttons,
}: PropsType) => {
  return (
    <div
      className={`py-4 px-6 bg-secondary-50 border-l-4 border-primary-600 ${className}`}
      style={{ gridColumn: `span ${cols} / span ${cols}` }}
    >
      <div
        className={`flex gap-3 justify-center ${buttons.length > 2 ? "flex-wrap" : ""}`}
      >
        {buttons
          .filter((button) => !button.isHidden)
          .map((button) => (
            <Fragment key={button.text}>
              {button?.link && (
                <LinkButton
                  path={button.link}
                  color="gray"
                  outline
                  text={button.text}
                />
              )}
              {button?.onClick && (
                <Button
                  onClick={button.onClick}
                  color="gray"
                  outline
                  text={button.text}
                  readonly={button.readonly}
                />
              )}
            </Fragment>
          ))}
      </div>
    </div>
  );
};
